export default "__VITE_ASSET__DrkOHtFj__"